"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleFailure = exports.customizeError = exports.parseErrorMessage = exports.parseErrorName = exports.handleSuccess = exports.mapErrorPayload = exports.mapPayload = exports.SCOPE = void 0;
exports.SCOPE = '@cart';
const mapPayload = (res) => ({
    status: res.status,
    statusText: res.statusText,
    data: res.data || {},
    isBigError: false,
});
exports.mapPayload = mapPayload;
const mapErrorPayload = (err) => {
    if (!err.response)
        return {
            status: err.name,
            statusText: err.message,
            data: {},
            error: {},
        };
    return {
        status: err.response.status,
        statusText: err.response.statusText,
        error: err.response.data,
    };
};
exports.mapErrorPayload = mapErrorPayload;
const handleSuccess = (dispatch, actionType) => (res) => {
    dispatch({ type: actionType, payload: (0, exports.mapPayload)(res) });
    return res;
};
exports.handleSuccess = handleSuccess;
const parseErrorName = (err) => {
    var _a, _b, _c, _d, _e;
    const errorStatus = `${exports.SCOPE} ${(_b = (_a = err === null || err === void 0 ? void 0 : err.response) === null || _a === void 0 ? void 0 : _a.status) !== null && _b !== void 0 ? _b : ''} ${(_d = (_c = err === null || err === void 0 ? void 0 : err.response) === null || _c === void 0 ? void 0 : _c.statusText) !== null && _d !== void 0 ? _d : 'Unknown'}`;
    const errorCode = (_e = err === null || err === void 0 ? void 0 : err.response) === null || _e === void 0 ? void 0 : _e.data.error_code;
    if (!errorCode)
        return errorStatus;
    return `${errorStatus} ${errorCode}`;
};
exports.parseErrorName = parseErrorName;
const parseErrorMessage = (err) => { var _a, _b, _c, _d; return (_d = (_b = (_a = err === null || err === void 0 ? void 0 : err.response) === null || _a === void 0 ? void 0 : _a.data.error_description) !== null && _b !== void 0 ? _b : (_c = err === null || err === void 0 ? void 0 : err.response) === null || _c === void 0 ? void 0 : _c.data.errorDescription) !== null && _d !== void 0 ? _d : err.message; };
exports.parseErrorMessage = parseErrorMessage;
const customizeError = (err) => {
    if (err.response) {
        err.name = (0, exports.parseErrorName)(err);
        err.message = (0, exports.parseErrorMessage)(err);
    }
};
exports.customizeError = customizeError;
const handleFailure = (dispatch, actionType) => (err) => {
    (0, exports.customizeError)(err);
    if (err.response && [429].includes(err.response.status)) {
        Promise.reject(err);
    }
    dispatch({ type: actionType, payload: (0, exports.mapErrorPayload)(err) });
    return Promise.reject(err);
};
exports.handleFailure = handleFailure;
